import { createSlice } from "@reduxjs/toolkit";


const FPdataArraySlice = createSlice({
    name:"fp",
    initialState:{
        rows:[],
        quantity:0,
        total: 0
    },
    reducers:{
        addRow:(state,action)=>{
            console.log(action.payload)
            console.log('payload logged inside state')
            state.rows.push(action.payload);
            state.total += 1

        },
        removeRow:(state,action)=>{
            state.total -= 1
            state.rows.splice(action.payload.index,1);

        },
        updateRow:(state,action)=>{
            const { index, updatedRow} = action.payload;
            // Replace the row at the specified index with the updated row object
            state.rows[index] = updatedRow;
            
        },
        resetRows: (state) => {
            state.rows = [];
            state.total = 0;
        }
    }
});


export const {addRow,updateRow,removeRow,resetRows} = FPdataArraySlice.actions
export default FPdataArraySlice.reducer